import { render } from "./UnitsArea.vue?vue&type=template&id=40ea2e5d&scoped=true"
import script from "./UnitsArea.vue?vue&type=script&lang=js"
export * from "./UnitsArea.vue?vue&type=script&lang=js"

import "./UnitsArea.vue?vue&type=style&index=0&id=40ea2e5d&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40ea2e5d"]])

export default __exports__